import { alpha, ListItemButton, Stack, SxProps, Typography } from "@mui/material";
import { useContext } from "react";
import Iconify from "src/components/Iconify";
import Image from "src/components/Image";
import palette from "src/theme/palette";
import { ConnectedEntity } from "src/types/apps";
import { entitiesLogoUrl } from "src/utils/formatUrl";

import Context from "../../../context";
import MaintenanceIconMobile from "../MaintenanceIconMobile";

// ----------------------------------------------------------------------

type Props = {
	item: ConnectedEntity;
};

const sx: SxProps = {
	borderRadius: 1,
	px: 2,
	py: 1,
	my: 0.5,
	backgroundColor: "white",
	justifyContent: "space-between",
	boxShadow: 1
};

export const EntityItemMobile = ({ item }: Props) => {
	const { actions, theme, themeType } = useContext(Context);

	const shadowColor = themeType === "DARK" ? "#000000" : palette.light.grey[500];
	const maintenance = item.maintenance;

	return (
		<ListItemButton
			key={item.id}
			onClick={() => (!maintenance ? actions.onSelectEntity(item) : {})}
			disableRipple={maintenance}
			sx={{
				...sx,
				backgroundColor: theme?.colors.contentBackground,
				boxShadow: `0 0 2px 0 ${alpha(shadowColor, 0.2)}, 0 12px 24px -4px ${alpha(
					shadowColor,
					0.12
				)}`,
				py: maintenance ? 2 : 1,
				cursor: maintenance ? "not-allowed" : "pointer"
			}}
		>
			<Stack flexDirection={"row"} alignItems={"center"}>
				<Image
					src={entitiesLogoUrl(item.id)}
					sx={{ width: 40, height: 40, alignSelf: "flex-start" }}
					fit='contain'
				/>
				<Typography variant='subtitle2' sx={{ ml: 2 }}>
					{item.name}
				</Typography>
			</Stack>
			<Iconify icon={"iconamoon:arrow-right-2"} color='text.secondary' />
			{maintenance && <MaintenanceIconMobile />}
		</ListItemButton>
	);
};

export default EntityItemMobile;
